import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CoaParameter, CoaResponse } from 'src/app/models/coa-parameter';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CoasService } from 'src/app/services/coas.service';

@Component({
  selector: 'app-certificates-of-analysis',
  templateUrl: './certificates-of-analysis.component.html',
  styleUrls: ['./certificates-of-analysis.component.scss']
})
export class CertificatesOfAnalysisComponent implements OnInit {
  createCoa = false;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  coas: CoaResponse[] = [];
  filterWord: string = "";
  filterCoas: CoaResponse[] = [];
  currentCoa = null;
  showDetailsId = null;
  loadingData = false;

  constructor(
    private coasService: CoasService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
      this.getCoas();
  }

  getCoas() {
    this.loadingData = true;
    this.coasService.getCoas().subscribe({
      next: (response: ResponseObject) => {
        this.coas = response.data;
        this.coas.sort((a, b) => Number(b.number) - Number(a.number));
        this.setCoas();
        this.loadingData = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener parametros coa","Error" )
        this.loadingData = false;
      }
    });
  }
  setCoas() {
    this.pagination.total = this.coas;
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  pageChange(event) {
    this.pagination.pageIndex = event.pageIndex;
    this.pagination.startElement = event.pageIndex * event.pageSize;
    this.pagination.filter = this.pagination.total.slice(this.pagination.startElement, this.pagination.startElement + event.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;

    this.pagination.filter = this.pagination.filter.sort((a, b) =>
      a.number.localeCompare(b.number)
    );
  }

  searching() {
    const word = this.filterWord.toLowerCase();
    this.pagination.total = this.coas.filter((c) => {
      return c.number.toString().toLowerCase().includes(word) || 
      c.code.toLowerCase().includes(word) || 
      c.batch.toLowerCase().includes(word) || 
      c.productData.name.toLowerCase().includes(word) || 
      c.productData.code.toLowerCase().includes(word)
    });
    this.resetPagination();
  }

  showDetails(item: CoaResponse) {
    this.showDetailsId = item.id;
  }

  deleteCoa(item: CoaResponse) {
    this.coasService.deleteCoasById(item.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("COA eliminado correctamente", "Exito");
        this.getCoas();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("No se pudo eliminar el COA", "Error");
      }
    });
  }

  downloadCOA(item: CoaResponse) {
    
  }

  closeCreateCoa(created) {
    if (created) {
      this.getCoas();
    }
    this.createCoa = false;
  }

  closeDetails() {
    this.showDetailsId = null;
  } 
}
